import { PropsWithChildren } from "react";
import styles from "./bottomOverlayContainer.module.scss";
import Button from "@Components/Button";
import useTranslationHook from "hooks/useTranslationHook";
import wrapperHOC from "@Utils/wrapperHOC";
import useWhitelabel from "hooks/useWhitelabel";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";

type BottomOverlayContainerProps = PropsWithChildren & {
  isClearActive?: boolean;
  onApplyClick: () => void;
  onClearClick: () => void;
  count?: number;
  hideLine?: boolean;
};

const BottomOverlayContainer = ({
  children,
  isClearActive = false,
  onApplyClick,
  onClearClick,
  count,
  hideLine = false,
}: BottomOverlayContainerProps) => {
  const { isWhitelabel } = useWhitelabel();
  const { t } = useTranslationHook();
  return (
    <div className={styles.container}>
      <div className={styles.filterContainer}>{children}</div>
      <div className={formatClassNames(styles.btnContainer, hideLine && styles.hideLine)}>
        <Button
          dataTestId="property-room-type-Reset-filter"
          variant="outline"
          onClick={onClearClick}
          greyDisabled={!isClearActive}
          className={styles.clearBtn}
        >
          {t("searchpage.components.filtersection.components.bottomoverlaycontainer.clear")}
        </Button>
        <Button
          dataTestId="property-room-type-Apply-filter"
          variant={isWhitelabel ? "whiteLabel_primary" : "primary"}
          onClick={onApplyClick}
          disable={!isClearActive}
        >
          {hideLine
            ? t("searchpage.components.filtersection.components.bottomoverlaycontainer.apply")
            : `${t("searchpage.components.filtersection.components.bottomoverlaycontainer.show")} ${
                count || "0"
              } ${t(
                "searchpage.components.filtersection.components.bottomoverlaycontainer.results",
              )}`}
        </Button>
      </div>
    </div>
  );
};

export default wrapperHOC(BottomOverlayContainer, {
  componentName: "BottomOverlayContainer-FilterSection-SearchPage",
  showForChina: true,
});
